export default __webpack_public_path__ + "static/media/nomadPlane.9999e868.jpg";